var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVpcListVGpu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "s33mvtb50a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.290196 0 0 0 0 0.466667 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)",
    filter: "url(#s33mvtb50a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#8793A3",
    strokeLinejoin: "round",
    d: "M13.459 15.333H32.5V27.45H13.459z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8793A3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.728 16.199h1.731v1.731h-1.73zM11.728 19.661h1.731v1.731h-1.73zM16.921 20.526h3.462v1.731h-3.462zM16.921 23.123h3.462v1.731h-3.462zM16.921 17.93h3.462v1.731h-3.462z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#8793A3",
    d: "M23.48 18.43h5.924v5.924H23.48z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8793A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 13h3.462v17.31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVpcListVGpu);
export default __webpack_public_path__ + "static/media/ico-vpc-list-v-gpu.dab70cb4d6cac9987c1bfb42f0d41ad0.svg";
export { ForwardRef as ReactComponent };